import { render } from "./ProductList.vue?vue&type=template&id=ff7df84a&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=ff7df84a&scoped=true&lang=scss"

import exportComponent from "/var/www/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff7df84a"]])

export default __exports__